module.exports = __webpack_public_path__ + "img/img1.eab19b65.png";